export default {"src":"/_next/static/media/last-mile-finance.5a503dd8.svg","height":31,"width":37};